import {
  ReactiveFormSubmitNavigationDecision,
  type ReactiveFormSubmitNavigationDecisionOptions,
  type ReactiveFormSubmitNavigationDecisionSnapshot,
} from './reactive-form-submit-navigation-decision';

export interface ReactiveFormSubmitCompletionPolicyOptions {
  readonly shouldEmitAfterSend?: boolean;
  readonly shouldNavigateBack?: boolean;
  readonly reason?: string;
}

export interface ReactiveFormSubmitCompletionPolicySnapshot {
  readonly shouldEmitAfterSend: boolean;
  readonly navigationDecision: ReactiveFormSubmitNavigationDecisionSnapshot;
}

/** Resolves the actions that must run after a successful submit response. */
export class ReactiveFormSubmitCompletionPolicy {
  public resolve(
    options: ReactiveFormSubmitCompletionPolicyOptions = {},
  ): ReactiveFormSubmitCompletionPolicySnapshot {
    return {
      shouldEmitAfterSend: options.shouldEmitAfterSend !== false,
      navigationDecision: ReactiveFormSubmitNavigationDecision.resolve(
        this.createNavigationOptions(options),
      ),
    };
  }

  private createNavigationOptions(
    options: ReactiveFormSubmitCompletionPolicyOptions,
  ): ReactiveFormSubmitNavigationDecisionOptions {
    const navigationOptions: ReactiveFormSubmitNavigationDecisionOptions = {};

    if (options.shouldNavigateBack !== undefined) {
      return options.reason === undefined
        ? { shouldNavigateBack: options.shouldNavigateBack }
        : {
            shouldNavigateBack: options.shouldNavigateBack,
            reason: options.reason,
          };
    }

    if (options.reason !== undefined) {
      return { ...navigationOptions, reason: options.reason };
    }

    return navigationOptions;
  }
}
